// Textele paginii de start, într-un singur loc, ca să poată fi schimbate ușor.

export const SITE_URL = "https://curs.viorelspinu.com";
export const COMPANIES_URL = "https://www.aileadership.ro/";
// Lecția arătată în „Cum arată o lecție”.
export const PREVIEW_LESSON = 2;
// Rezervă pentru PDF-ul ei, dacă nu se poate citi catalogul lessons.json.
export const PREVIEW_PDF_URL = SITE_URL + "/2_8636ee04378c4edb49836d5ddb2a3d9de3855da59ca1c6aaccff9e3c7e3c83e3.pdf";

export const STEPS = [
    { icon: "form", title: "Te înscrii", text: "Lași numele și adresa de email." },
    { icon: "pdf", title: "Primești Lecția 1", text: "Imediat, pe email: un PDF de cam 20 de pagini." },
    { icon: "calendar", title: "Apoi, o lecție pe săptămână", text: "O citești când ai timp, pe telefon sau pe calculator." },
];

// Câteva lecții reale, grupate pe etape. Titlurile sunt cele din emailurile lecțiilor.
export const STAGES = [
    {
        name: "Bazele",
        text: "Ce e AI-ul și cum îi ceri ce vrei.",
        lessons: [1, 5, 6, 8],
    },
    {
        name: "Verifici ce-ți spune",
        text: "Cum îți dai seama când greșește sau doar îți dă dreptate.",
        lessons: [18, 20, 24, 58],
    },
    {
        name: "Excel și acte, fără bătăi de cap",
        text: "Pornești de la un teanc de hârtii și ajungi la un tabel verificat.",
        lessons: [62, 63, 65, 70],
    },
    {
        name: "Treburi de birou, mai repede",
        text: "Traduceri, notițe, transcrieri și contracte.",
        lessons: [9, 22, 43, 66],
    },
    {
        name: "Unelte făcute de tine",
        text: "Îți faci singur ce-ți trebuie, fără să scrii cod.",
        lessons: [40, 50, 69, 71],
    },
    {
        name: "Agenți AI",
        text: "Un AI care face o treabă de la cap la coadă, iar tu verifici rezultatul.",
        lessons: [31, 61, 64, 68],
    },
];


// Toate lecțiile, în ordine. Când apare o lecție nouă, adaug-o la final.
export const LESSONS = [
    "Harta AI-ului: ce este, de ce a explodat și încotro merge",
    "Cum apare un răspuns din numere",
    "Contextul, pașii și dovezile fac rezultatul AI controlabil",
    "Cum răspunde ChatGPT",
    "Cum scrii un prompt bun pentru AI",
    "De la cerere la rezultat verificabil",
    "Exemple care ghidează răspunsul",
    "Când merită să pui AI-ul să gândească",
    "Cum traduci profesionist cu AI",
    "Cum răspunde AI-ul din documentele tale",
    "Din intenție în imagine",
    "De la idee vagă la imagine utilizabilă",
    "Consistența personajelor în imaginile generate cu AI",
    "Scrie o poveste cu AI",
    "Același personaj, scenă după scenă",
    "Un răspuns fluent nu este neapărat un răspuns cert",
    "Stilul personal de scriere",
    "Halucinațiile AI: de ce apar și cum le recunoști",
    "Ce înseamnă „corect” când lucrezi cu AI",
    "Ce s-a schimbat între două documente?",
    "De la link la dovadă",
    "Din notițe dezordonate în decizii și acțiuni",
    "Când schimbi promptul și când schimbi modelul",
    "Când AI-ul îți confirmă preferința",
    "Design interior cu AI",
    "Analiza datelor cu ChatGPT",
    "Website Design cu AI",
    "De la LLM la agenți AI: de la răspuns la acțiune",
    "Anatomia unui agent AI",
    "Pune Cowork la treabă",
    "Agenți AI în lumea reală: ce funcționează și unde merită",
    "Fereastra de context",
    "De ce „uită” ChatGPT: context, memorie și RAG",
    "Nu-ți pierde contextul în conversații lungi",
    "Context și RAG: lacul cu pești",
    "Agentul s-a oprit la jumătate. Ce faci?",
    "MCP în detaliu",
    "AI în timp real",
    "Cum învață, de fapt, un model AI",
    "Custom GPT — un ChatGPT configurat pentru un scop precis",
    "Text-to-Speech",
    "Clonarea vocii",
    "Din voce în text: transcrierea audio cu AI",
    "Whisper avansat: de la înregistrare la materiale reutilizabile",
    "Gemini Notebook (fost NotebookLM): din surse, răspunsuri și materiale",
    "Gemini Notebook: din surse în Audio și Video Overview",
    "Dintr-o fotografie, un clip coerent",
    "Gemini Notebook — Alege formatul după ce vrei să obții",
    "Studioul video AI multilingv",
    "Programare cu AI — prima aplicație fără să scrii cod",
    "De la idee la aplicație",
    "De la proiect unic la automatizare reutilizabilă",
    "AI pe calculatorul tău",
    "Securitatea AI: cum recunoști instrucțiunile ostile și limitezi riscul",
    "De la prompt la proces: construiește rețete reutilizabile cu AI",
    "Învață practic cu ChatGPT și NotebookLM",
    "De ce nu îți ia AI-ul jobul",
    "Cum verifici munca AI-ului",
    "AI-ul e deja în firma ta",
    "Automatizează ceva banal",
    "Cum delegi sarcini unui agent AI",
    "Dintr-un teanc de documente într-un Excel verificat",
    "Din bonuri fiscale într-un Excel verificat",
    "Procesarea automată a emailurilor cu Cowork",
    "Unește două Exceluri cu ajutorul unui agent AI",
    "Dintr-un contract într-un checklist reutilizabil",
    "Găsește firme potrivite pentru oferta ta",
    "Află ce facturi au fost plătite cu ajutorul unui agent AI",
    "Un asistent pentru întrebările colegilor",
    "Automatizează repartizarea facturilor din Excel cu AI",
    "Anunță-mă când scade prețul",
];

export const LESSON_PAGES = [
    { id: "l2-p01", alt: "Prima pagină din Lecția 2: Cum apare un răspuns din numere" },
    { id: "l2-p12", alt: "O pagină din Lecția 2: creierul nostru confundă ușor fluența cu inteligența" },
    { id: "l2-p18", alt: "Pagina „Lecția 2 într-o pagină”, rezumatul de la final" },
];

// Citate exacte din postările lui Viorel.
export const QUOTE = "„Un AI îți confirmă aproape orice îi sugerezi. E un junior care n-o să te contrazică niciodată dacă-i sufli tu replica.”";
export const QUOTE_AFTER = "De-asta, în curs înveți și cum să-i verifici răspunsurile.";

// Mesaje reale primite de la cei care citesc lecțiile (răspunsuri pe email și butonul „Mi-a plăcut”).
// Fără nume: oamenii i-au scris lui Viorel, nu pentru site. Textul e cel original; am adăugat doar diacriticele.
// „src” spune de unde vine: lecția, sau „newsletter” pentru emailurile „Un tool AI pe săptămână”.
export const TESTIMONIALS = [
    { text: "Am învățat să fac prompturile aplicate, cu mai mult context, să-i dau toate detaliile necesare pentru a fi cât mai exact, din prisma meseriei de expert contabil. […] Am reușit să îmi creez un registru de lucru Excel pentru analiza financiară la o închidere de lună.", src: "Lecția 4, iulie 2026" },
    { text: "Foarte bine concepută lecția. Elemente de bază explicate pe înțelesul tuturor. NU m-am gândit că poate fi așa interesant de la prima lecție. Mi-ai explicat noțiunile pe care le auzeam în conversațiile colegilor, pe grupul de WhatsApp... acum am înțeles.", src: "Lecția 1, iulie 2026" },
    { text: "Ca de obicei, curs excelent!!! […] Sincer, până în luna mai 2026 nici nu văzusem vreodată cum arată un script.", src: "Lecția 4, august 2026" },
    { text: "Viorel, știi ce spui. Mă înveți să folosești AI-ul. […] Acu' buchisesc capitolul 8 și încep să simt că am hățuri cu care controlez Cowork.", src: "Lecția 8, septembrie 2026" },
    { text: "Este foarte utilă, ca toate lecțiile tale, de altfel. Mulțumesc. Oferta noastră de produse angro este într-un document Word care a devenit complicată până și pentru mine :) ...mă gândesc să aplic recomandările tale.", src: "Lecția 56, iunie 2026" },
    { text: "Cursul tău introductiv a fost foarte util, pentru că m-a făcut să înțeleg bazele AI și să îmi explic unele limitări când foloseam ChatGPT, Gemini sau Perplexity.", src: "primele lecții, octombrie 2025" },
    { text: "Eu sunt bucătar și mă ajută mult să schimb meniurile și să îmbunătățesc rețetele.", src: "despre curs, februarie 2025" },
    { text: "Mi-a plăcut Lecția 8! Asta m-a luminat cumva! Mulțumesc", src: "Lecția 8, septembrie 2026" },
    { text: "Mulțumesc frumos pentru cursurile primite, sunt foarte faine și utile.", src: "Lecția 15, octombrie 2026" },
    { text: "E ok și pe înțelesul tuturor. Mulțumesc", src: "Lecția 3, august 2026" },
    { text: "Folosesc NotebookLM, dar ideea de a face un fișier INSTRUCTIONS.txt și a-l încărca aici reprezintă o noutate. […] Am să-l încerc cu prima ocazie. Mulțumesc pentru lecție!", src: "newsletter, octombrie 2025" },
    { text: "Excelentă și foarte actuală! Mulțumesc!", src: "Lecția 42, noiembrie 2025" },
    { text: "Super educativ și pe înțelesul meu.", src: "newsletter, octombrie 2025" },
    { text: "Am făcut o simulare... sigur îl voi utiliza. Mulțumesc", src: "newsletter, octombrie 2025" },
    { text: "Mi-a plăcut Lecția 6, și 1, 2, 3, 4, 5! Mulțumesc! Cele bune!", src: "Lecția 6, octombrie 2025" },
    { text: "Mulțumesc din suflet!", src: "Lecția 19, august 2026" },
];

export const FAQ = [
    {
        q: "E pentru mine dacă nu sunt „tehnic”?",
        a: "Da. Cursul e scris pentru oameni care lucrează cu emailuri, documente și tabele. Explic fiecare termen nou când apare.",
    },
    {
        q: "Folosesc deja ChatGPT. Mai am ce învăța?",
        a: "Probabil că da. Primele lecții pun bazele, apoi ajungem la analiza datelor, la verificarea răspunsurilor, la un ChatGPT personal care știe deja cum lucrezi și la agenți AI care preiau sarcinile repetitive.",
    },
    {
        q: "Pot trimite cursul colegilor sau echipei mele?",
        a: "Sigur. Trimite-le linkul și fiecare se înscrie cu adresa lui, sau dă-le forward la emailul cu lecția, cu PDF-ul atașat.",
    },
    {
        q: "Pot sări direct la lecțiile care mă interesează?",
        a: "Nu. Lecțiile vin în ordine, pentru că fiecare se sprijină pe cele dinainte. Dacă rămâi în urmă, te așteaptă în inbox.",
    },
    {
        q: "Îmi va lua AI-ul locul de muncă?",
        a: "AI-ul poate face deja o parte din munca ta. Cine știe să lucreze cu el își termină, de obicei, treaba mai repede. Una dintre lecții e despre asta: ce preia AI-ul și ce rămâne la tine.",
    },
    {
        q: "Chiar e gratuit? Ce câștigi tu din asta?",
        a: "Da, toate lecțiile, inclusiv cele care vor veni. Scriu cursul pentru că îmi place să explic. Banii îi câștig din altceva: țin workshopuri plătite pentru firme, prin AI Leadership, și uneori le anunț în newsletter.",
    },
    {
        q: "Ce faci cu adresa mea de email?",
        a: "O folosesc doar ca să-ți trimit lecțiile și newsletterul. O păstrez criptată și n-o dau nimănui. Te dezabonezi cu un clic, din orice email.",
    },
];

export const SHARE_TEXT = "Curs gratuit de AI, pe email, de la Viorel Spînu. O lecție pe săptămână, explicată pe românește: " + SITE_URL;

// Apariții publice, fiecare cu articolul de pe blog ca dovadă. Aceleași ca în secțiunea In Action de pe aileadership.ro.
export const IN_ACTION = [
    { img: "ia-02", href: "https://www.viorelspinu.com/2025/05/ai-for-translators.html", alt: "Workshop AI pentru traducători" },
    { img: "ia-41", href: "https://www.viorelspinu.com/2025/05/ronog-11-tools-and-recipe-is-all-you.html", alt: "Speaker la RONOG 11" },
    { img: "ia-01", href: "https://www.viorelspinu.com/2025/05/i-like-it-on-ai-august-2025.html", alt: "Emisiunea I Like IT, ProTV" },
    { img: "ia-03", href: "https://www.viorelspinu.com/2025/11/blog-post.html", alt: "Speaker la CyberCon România" },
    { img: "ia-04", href: "https://www.viorelspinu.com/2025/11/speaker-at-ing-connect.html", alt: "Speaker la ING Connect" },
    { img: "ia-05", href: "https://www.viorelspinu.com/2025/10/stirile-protv-understanding-chatgpts.html", alt: "Interviu la Știrile ProTV" },
    { img: "ia-06", href: "https://www.viorelspinu.com/2025/05/i-was-invited-by-lauder-reut-high.html", alt: "Workshop la Lauder-Reut" },
    { img: "ia-12", href: "https://www.viorelspinu.com/2025/06/stirile-protv-how-much-costs-thankyou.html", alt: "Interviu la Știrile ProTV, iunie 2025" },
    { img: "ia-07", href: "https://www.viorelspinu.com/2025/05/speaking-at-ronog-10-ai-in-network.html", alt: "Speaker la RONOG 10" },
    { img: "ia-08", href: "https://www.viorelspinu.com/2025/05/ai-panel-at-astrofest.html", alt: "Panel despre AI la AstroFest" },
    { img: "ia-16", href: "https://www.viorelspinu.com/2025/04/live-on-tv-from-passive-assistants-to.html", alt: "Interviu la Știrile ProTV, aprilie 2025" },
    { img: "ia-09", href: "https://www.viorelspinu.com/2025/05/i-was-invited-to-speak-about-practical.html", alt: "Bucharest Summer University, AI practic" },
    { img: "ia-10", href: "https://www.viorelspinu.com/2025/04/speaker-at-leadwell-conference-ai-as.html", alt: "Speaker la LeadWell 2025" },
    { img: "ia-18", href: "https://www.viorelspinu.com/2025/04/live-on-tv-from-ice-blocks-to-ai-code.html", alt: "Interviu la Știrile ProTV, aprilie 2025" },
    { img: "ia-11", href: "https://www.viorelspinu.com/2025/04/empretec-apar-biz-interview.html", alt: "Interviu Empretec" },
    { img: "ia-20", href: "https://www.viorelspinu.com/2025/04/live-on-national-tv-discussing.html", alt: "Interviu la ProTV" },
    { img: "ia-13", href: "https://www.viorelspinu.com/2025/05/on-national-tv-about-ai.html", alt: "Invitat la TVR2" },
    { img: "ia-14", href: "https://www.viorelspinu.com/2025/05/lauder.html", alt: "Workshop la Lauder-Reut" },
    { img: "ia-22", href: "https://www.viorelspinu.com/2024/08/stirileprotv-august-2024.html", alt: "Interviu la Știrile ProTV, august 2024" },
    { img: "ia-15", href: "https://www.viorelspinu.com/2025/04/ai-in-supply-chain.html", alt: "Articol în revista Cariere" },
    { img: "ia-17", href: "https://www.viorelspinu.com/2024/11/insights-on-ai-from-shifthappens.html", alt: "Speaker la Shift Happens" },
    { img: "ia-24", href: "https://www.viorelspinu.com/2025/03/viorel-spinu-on-stirile-protv-exploring.html", alt: "Interviu la Știrile ProTV, martie 2025" },
    { img: "ia-19", href: "https://www.viorelspinu.com/2024/11/sharing-ai-insights-with-faculty-of.html", alt: "Workshop la Universitatea Tehnică de Construcții" },
    { img: "ia-26", href: "https://www.viorelspinu.com/2025/02/viorel-spinu-live-on-stirileprotv.html", alt: "Interviu la Știrile ProTV, februarie 2025" },
    { img: "ia-21", href: "https://www.viorelspinu.com/2023/06/interview-on-ai-for-gandul-newspaper.html", alt: "Interviu pentru Gândul" },
    { img: "ia-23", href: "https://www.viorelspinu.com/2023/11/aispeaker-at-absl-11th-annual-conference.html", alt: "Speaker la conferința ABSL" },
    { img: "ia-27", href: "https://www.viorelspinu.com/2025/01/viorel-spinu-live-on-protv-news-january.html", alt: "Interviu la Știrile ProTV, ianuarie 2025" },
    { img: "ia-25", href: "https://www.viorelspinu.com/2023/04/speaker-at-estee-lauder-on-artificial.html", alt: "Speaker la Estée Lauder" },
    { img: "ia-29", href: "https://www.viorelspinu.com/2023/11/speaker-at-faculty-of-management.html", alt: "Speaker la ASE, Facultatea de Management" },
    { img: "ia-28", href: "https://www.viorelspinu.com/2023/06/ive-been-on-protv-ilikeit-june-2023.html", alt: "Emisiunea I Like IT, ProTV, iunie 2023" },
    { img: "ia-32", href: "https://www.viorelspinu.com/2023/11/ai-unexpected-scenarios-speaker-at.html", alt: "AI în marketing, la ASE" },
    { img: "ia-30", href: "https://www.viorelspinu.com/2023/04/ive-been-on-protv-ilikeit-april-2023.html", alt: "Emisiunea I Like IT, ProTV, aprilie 2023" },
    { img: "ia-33", href: "https://www.viorelspinu.com/2023/04/speaker-at-marketing-waves-conference.html", alt: "Speaker la Marketing Waves" },
    { img: "ia-34", href: "https://www.viorelspinu.com/2023/03/speaker-dwftalks.html", alt: "Speaker la DWF Talks" },
    { img: "ia-31", href: "https://www.viorelspinu.com/2023/03/ive-been-live-on-tv.html", alt: "Interviu live la ProTV, martie 2023" },
    { img: "ia-35", href: "https://www.viorelspinu.com/2023/05/speaker-at-bigdatameetup-bucharest-may.html", alt: "Speaker la Big Data Meetup București" },
    { img: "ia-36", href: "https://www.viorelspinu.com/2023/05/speaker-at-cegeka-ai-data-alchemy.html", alt: "Speaker la Cegeka" },
    { img: "ia-39", href: "https://www.viorelspinu.com/2025/05/interview-on-stirile-protv-september.html", alt: "Interviu la Știrile ProTV, septembrie" },
    { img: "ia-42", href: "https://www.viorelspinu.com/2025/05/pro-tv-bank-chatbot-called-customer.html", alt: "Interviu la Știrile ProTV: chatbotul unei bănci" },
    { img: "ia-40", href: "https://www.viorelspinu.com/2021/04/thebeerkeyboard.html", alt: "Proiectul The Beer Keyboard" },
    { img: "ia-44", href: "https://www.viorelspinu.com/2025/05/ai-agents-for-network-operators-my.html", alt: "Workshop despre agenți AI la Interlan" },
    { img: "ia-43", href: "https://www.viorelspinu.com/2025/05/pro-tv-ilikeit-chinas-kimi-k3-open.html", alt: "I Like IT, ProTV: modelul Kimi K3" },
    { img: "ia-50", href: "https://www.viorelspinu.com/2025/05/anti-aging-festival-2026-what-ai-can-do.html", alt: "Speaker la Anti-Aging Festival 2026" },
    { img: "ia-51", href: "https://www.viorelspinu.com/2025/05/leadwell-2026-ai-from-hype-to-reality.html", alt: "Panel la LeadWell 2026" },
    { img: "ia-45", href: "https://www.viorelspinu.com/2025/05/why-gen-z-is-going-quiet-online-my-pro.html", alt: "ProTV: de ce tac tinerii online" },
    { img: "ia-52", href: "https://www.viorelspinu.com/2025/05/2day-ambassador-at-laude-reut-ai-and.html", alt: "Panel la 2DAY Ambassador, Laude-Reut" },
    { img: "ia-46", href: "https://www.viorelspinu.com/2025/05/the-eus-new-labels-for-ai-content-good.html", alt: "ProTV: etichetele UE pentru conținut AI" },
    { img: "ia-53", href: "https://www.viorelspinu.com/2026/05/responsible-ai-in-practice-at-ase.html", alt: "AI responsabil, la masterul CRM de la ASE" },
    { img: "ia-54", href: "https://www.viorelspinu.com/2026/03/live-on-tv-ai-is-clicking-your-mouse.html", alt: "Live la TV: AI-ul care îți mișcă mouse-ul" },
    { img: "ia-47", href: "https://www.viorelspinu.com/2025/05/when-ai-plays-matchmaker-and-texts-for.html", alt: "ProTV: AI-ul ca pețitor" },
    { img: "ia-56", href: "https://www.viorelspinu.com/2025/11/on-tv-ai-in-music.html", alt: "La TV: AI în muzică" },
    { img: "ia-58", href: "https://www.viorelspinu.com/2025/05/ai-workshop-in-bosch.html", alt: "Workshop AI la conferința HR din Timișoara" },
    { img: "ia-48", href: "https://www.viorelspinu.com/2025/05/pro-tv-ai-assistants-on-whatsapp-and.html", alt: "ProTV: asistenții AI pe WhatsApp" },
    { img: "ia-59", href: "https://www.viorelspinu.com/2023/06/speaker-at-marketing-bucharest.html", alt: "Speaker la Facultatea de Marketing" },
    { img: "ia-49", href: "https://www.viorelspinu.com/2025/05/pro-tv-ilikeit-what-world-models-are.html", alt: "I Like IT, ProTV: ce sunt world models" },
    { img: "ia-60", href: "https://www.viorelspinu.com/2023/05/speaker-brownbag-keep-calm-and-use-ai.html", alt: "Speaker la BrownBag: Keep Calm and Use AI" },
    { img: "ia-61", href: "https://www.viorelspinu.com/2023/04/speaker-at-biglifeproject-on-ai-impact.html", alt: "Speaker la BigLifeProject" },
    { img: "ia-55", href: "https://www.viorelspinu.com/2025/05/live-on-protv-should-we-trust-ai.html", alt: "Live la ProTV: putem avea încredere în AI?" },
    { img: "ia-63", href: "https://www.viorelspinu.com/2019/07/cegeka-innovation-breakfast.html", alt: "Cegeka Innovation Breakfast" },
    { img: "ia-64", href: "https://www.viorelspinu.com/2019/08/aib-august-meetup-cegeka.html", alt: "A.I. Bucharest Meetup la Cegeka" },
    { img: "ia-57", href: "https://www.viorelspinu.com/2025/05/interview-on-stirile-protv-may-2025.html", alt: "Interviu la Știrile ProTV, mai 2025" },
    { img: "ia-62", href: "https://www.viorelspinu.com/2023/01/ive-been-on-protv-evening-news.html", alt: "La Știrile ProTV despre AI, ianuarie 2023" },
];
